/**
 * KullaniciFiltreleri.jsx — Kullanıcılar sayfasının "Filtreler" paneli (backlog #379)
 *
 * Tamamı kontrollü: `filtre` nesnesi kullaniciListe.js'teki BOS_FILTRE şeklindedir ve `GET /users/kullanici-listesi`
 * parametrelerine 1:1 eşlenir (Yetki Yönetimi › Kullanıcılar ile aynı süzgeç kümesi, #309). Uygulama / debounce
 * sayfanın işi — burada yalnızca düzenlenir. Arama ve sıralama araç çubuğunda durur, buraya girmez.
 *
 * Props: filtre · onChange(next) · roller [{ id, ad }] · fuarlar [{ fuarId, ad }] · aktifSayi · onTemizle
 */
import React from "react";
import { Button, Col, Input, Row } from "reactstrap";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import FirmaSearchSelect from "../Firma/FirmaSearchSelect";
import TarihGirdisi from "../Common/TarihGirdisi";
import { FIRMA_ROLLERI } from "./kullaniciListe";

function Alan({ label, children }) {
  return (
    <>
      <div className="small text-muted mb-1">{label}</div>
      {children}
    </>
  );
}

export default function KullaniciFiltreleri({ filtre, onChange, roller = [], fuarlar = [], aktifSayi = 0, onTemizle }) {
  const { t } = useTranslation("components");
  const set = (patch) => onChange({ ...filtre, ...patch });
  const secim = (anahtar) => (e) => set({ [anahtar]: e.target.value });
  const hepsi = <option value="">{t("kullaniciFiltreleri.hepsi")}</option>;

  return (
    <>
      <Row className="g-3">
        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.rol")}>
            <Input type="select" bsSize="sm" value={filtre.groupId} onChange={secim("groupId")}>
              {hepsi}
              {roller.map((r) => <option key={r.id} value={r.id}>{r.ad}</option>)}
            </Input>
          </Alan>
        </Col>
        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.durum")}>
            <Input type="select" bsSize="sm" value={filtre.active} onChange={secim("active")}>
              {hepsi}
              <option value="1">{t("kullaniciFiltreleri.aktif")}</option>
              <option value="0">{t("kullaniciFiltreleri.pasif")}</option>
            </Input>
          </Alan>
        </Col>
        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.giris")}>
            <Input type="select" bsSize="sm" value={filtre.girisVar} onChange={secim("girisVar")}>
              {hepsi}
              <option value="true">{t("kullaniciFiltreleri.girisYapmis")}</option>
              <option value="false">{t("kullaniciFiltreleri.hicGirisYapmamis")}</option>
            </Input>
          </Alan>
        </Col>
        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.fuar")}>
            <Input type="select" bsSize="sm" value={filtre.fuarId} onChange={secim("fuarId")}>
              {hepsi}
              {fuarlar.map((f) => <option key={f.fuarId} value={f.fuarId}>{f.ad}</option>)}
            </Input>
          </Alan>
        </Col>

        <Col xl={4} md={12}>
          <Alan label={t("kullaniciFiltreleri.firma")}>
            <FirmaSearchSelect
              forceLive value={filtre.firma} onChange={(firma) => set({ firma })}
              placeholder={t("kullaniciFiltreleri.firmaYeri")}
            />
          </Alan>
        </Col>
        <Col xl={2} md={6}>
          <Alan label={t("kullaniciFiltreleri.firmaBaglantisi")}>
            <Input type="select" bsSize="sm" value={filtre.firmaVar} onChange={secim("firmaVar")}>
              {hepsi}
              <option value="true">{t("kullaniciFiltreleri.firmasiVar")}</option>
              <option value="false">{t("kullaniciFiltreleri.firmasiYok")}</option>
            </Input>
          </Alan>
        </Col>
        <Col xl={2} md={6}>
          <Alan label={t("kullaniciFiltreleri.firmaUyrugu")}>
            <Input type="select" bsSize="sm" value={filtre.firmaNation} onChange={secim("firmaNation")}>
              {hepsi}
              <option value="1">{t("kullaniciFiltreleri.yerli")}</option>
              <option value="2">{t("kullaniciFiltreleri.yabanci")}</option>
            </Input>
          </Alan>
        </Col>
        <Col xl={4} md={6}>
          <Alan label={t("kullaniciFiltreleri.firmaninFuarRolu")}>
            <Input type="select" bsSize="sm" value={filtre.firmaTypeId} onChange={secim("firmaTypeId")}>
              {hepsi}
              {FIRMA_ROLLERI.map((r) => <option key={r.value} value={r.value}>{t(r.etiketKey)}</option>)}
            </Input>
          </Alan>
        </Col>

        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.sonGirisBaslangic")}>
            <TarihGirdisi value={filtre.sonGirisBaslangic} onChange={(v) => set({ sonGirisBaslangic: v })} />
          </Alan>
        </Col>
        <Col xl={3} md={6}>
          <Alan label={t("kullaniciFiltreleri.sonGirisBitis")}>
            <TarihGirdisi value={filtre.sonGirisBitis} onChange={(v) => set({ sonGirisBitis: v })} />
          </Alan>
        </Col>
      </Row>

      {aktifSayi > 0 && (
        <div className="d-flex justify-content-end mt-3">
          <Button color="light" size="sm" onClick={onTemizle}>
            <X size={13} className="me-1" />{t("kullaniciFiltreleri.filtreleriTemizle")}
          </Button>
        </div>
      )}
    </>
  );
}
